import { GenericCategoryDisplayer } from '@components';
import { useGenericCart } from '@contexts/GenericCartContext/GenericCartContext';
import { Button, Container, Icon, IconButton, Typography } from '@design-system';
import React from 'react';
import { FaShoppingBasket, FaStar } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import './EpiPage.scss';

export const EpiPage: React.FC = () => {
    const { getTotalItems } = useGenericCart({ type: 'epi' });

    const totalItems = getTotalItems();
    const navigate = useNavigate();

    return (
        <div className="epi-page">
            <Container className="epi-page-header" padding="medium large" radius="none" flexRow>
                <Button color="green" variant="secondary" size="small" onClick={() => navigate('/sante-securite/epi/orders')}>
                    <Typography intrinsic="h4">Mes demandes EPI</Typography>
                </Button>

                <div className="epi-page-header-cart">
                    <IconButton
                        icon={<Icon icon={<FaShoppingBasket />} size={24} color="grey" />}
                        onClick={() => navigate('/sante-securite/epi/cart')}
                    />
                    {totalItems ? (
                        <Typography intrinsic="h4" className="total-items">
                            {totalItems}
                        </Typography>
                    ) : (
                        <></>
                    )}
                </div>
            </Container>

            <Container padding="medium large" radius="none">
                <Container className="header-categories mb-medium-spacing" padding="none" flexRow>
                    <Typography intrinsic="h2">Catégories EPI</Typography>
                    <Button
                        color="grey"
                        variant="tertiary"
                        size="small"
                        icon={<FaStar />}
                        secondaryIcon={<MdKeyboardArrowRight className="ml--x-small-spacing" />}
                        className="no-padding"
                        onClick={() => navigate('/sante-securite/epi/orders/favorites')}
                    >
                        <Typography intrinsic="h4">Favoris</Typography>
                    </Button>
                </Container>
                <GenericCategoryDisplayer type="epi" basePath="/sante-securite/epi" />
            </Container>
        </div>
    );
};
